export default __webpack_public_path__ + "static/media/download-icon.5374af6d.svg";